import { ITableColumn } from "src/app/common/components/table/interfaces/table-column";
import { RegionCellComponent } from "../../cells/region-cell.component";

export const getMunicipalitiesTableConfig = (
  isExcavationNotificationEnabled: boolean
): { columns: Array<ITableColumn>; nestedColumns: Array<ITableColumn> } => {
  const columns: Array<ITableColumn> = [
    {
      id: "regionName",
      type: "custom",
      key: "USER_SETTINGS.MUNICIPALITY",
      style: {
        width: "150px"
      },
      customTemplate: RegionCellComponent
    },
    {
      id: "internal",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.INTERNAL",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeIntEmailCount",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_ELECTRICITY",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeIntEmailCountGas",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_GAS",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeIntSmsCount",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_SMS_CNT_ELECTRICITY",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeIntSmsCountGas",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_SMS_CNT_GAS",
      style: {
        width: "90px",
        "border-right-width": "1px",
        "border-right-style": "solid"
      }
    },
    {
      id: "external",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.EXTERNAL",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeExtEmailCount",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_ELECTRICITY",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeExtEmailCountGas",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_GAS",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeExtSmsCount",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_SMS_CNT_ELECTRICITY",
      style: {
        width: "90px"
      }
    },
    {
      id: "activeExtSmsCountGas",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_SMS_CNT_GAS",
      style: {
        width: "90px"
      }
    },
    {
      id: "expand",
      type: "action",
      actionIcon: "ec_networks_mix_addrow",
      selectedIcon: "ec_networks_mix_deleterow",
      key: "",
      style: {
        "text-align": "center",
        width: "60px"
      }
    }
  ];

  if (isExcavationNotificationEnabled) {
    const internalExcavationColumn: ITableColumn = {
      id: "activeIntEmailCountExcavation",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_EXCAVATION",
      style: {
        width: "125px"
      }
    };

    const externalExcavationColumn: ITableColumn = {
      id: "activeExtEmailCountExcavation",
      type: "text",
      key: "USER_SETTINGS.LIST_USERS.ACTIVE_EMAIL_CNT_EXCAVATION",
      style: {
        width: "125px"
      }
    };

    columns.splice(4, 0, internalExcavationColumn);
    columns.splice(10, 0, externalExcavationColumn);
  }

  return {
    columns,
    nestedColumns: [
      {
        id: "name",
        type: "text",
        key: "USER_SETTINGS.NAME",
        style: {
          width: "240px"
        }
      },
      {
        id: "role",
        type: "text",
        key: "USER_SETTINGS.ROLE",
        style: {
          width: "80px"
        }
      },
      {
        id: "email",
        type: "text",
        key: "USER_SETTINGS.LIST_USERS.EMAIL",
        style: {
          width: "240px"
        }
      },
      {
        id: "emailConfig",
        type: "notification-settings",
        key: "USER_SETTINGS.LIST_USERS.EMAIL_CONFIG_ELECTRICITY",
        style: {
          width: "135px"
        }
      },
      {
        id: "emailConfigGas",
        type: "notification-settings",
        key: "USER_SETTINGS.LIST_USERS.EMAIL_CONFIG_GAS",
        style: {
          width: "135px"
        }
      },
      {
        id: "phone",
        type: "text",
        key: "USER_SETTINGS.LIST_USERS.PHONE",
        style: {
          width: "240px"
        }
      },
      {
        id: "phoneConfig",
        type: "notification-settings",
        key: "USER_SETTINGS.LIST_USERS.SMS_CONFIG_ELECTRICITY",
        style: {
          width: "135px"
        }
      },
      {
        id: "phoneConfigGas",
        type: "notification-settings",
        key: "USER_SETTINGS.LIST_USERS.SMS_CONFIG_GAS",
        style: {
          width: "135px"
        }
      }
    ]
  };
};
